import {
    ADD_ACTIVITY_TO_COMPARE_LIST,
    CLEAR__COMPARE_LIST,
    REMOVE_ACTIVITY_FROM_COMPARE_LIST
} from './actions';

export function addActivityToCompareList(activity) {
    return { type: ADD_ACTIVITY_TO_COMPARE_LIST, activity };
}

export function removeActivityFromCompareList(activityId) {
    return { type: REMOVE_ACTIVITY_FROM_COMPARE_LIST, activityId };
}

export function clearCompareList() {
    return { type: CLEAR__COMPARE_LIST };
}
